import { gql } from '@apollo/client';

export const ADYEN_PAYMENT_METHODS = gql`
  mutation AdyenPaymentMethods($input: AdyenPaymentMethodsInput!) {
    adyenPaymentMethods(input: $input) {
      clientKey
      environment
      paymentMethods
      checkoutAttemptId
    }
  }
`;
